(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["om-collection-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-om-filter-toggle]').forEach((button) => {
    if (button.dataset.ready) return;
    button.dataset.ready = 'true';
    button.addEventListener('click', () => {
      const sidebar = document.getElementById(button.getAttribute('aria-controls'));
      const open = sidebar.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(open));
    });
  });
  document.querySelectorAll('[data-om-sort-form]').forEach((form) => {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    form.addEventListener('change', (event) => {
      if (event.target.name === 'sort_by') form.requestSubmit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["om-product-magnetic"] && !Shopify.designMode) return;
  try {
    
  function initOmMagnetic(root) {
    if (root.dataset.omReady === 'true') return;
    root.dataset.omReady = 'true';
    const hero = root.querySelector('[data-om-hero-image]');
    const heroLink = root.querySelector('[data-om-hero-link]');
    root.querySelectorAll('[data-om-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        hero.src = thumb.dataset.src;
        hero.alt = thumb.dataset.alt;
        heroLink.href = thumb.dataset.full;
        root.querySelectorAll('[data-om-thumb]').forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
      });
    });
    const variantId = root.querySelector('[data-om-variant-id]');
    const price = root.querySelector('[data-om-price]');
    const submit = root.querySelector('[data-om-submit]');
    root.querySelectorAll('[data-om-variant]').forEach((input) => {
      input.addEventListener('change', () => {
        variantId.value = input.value;
        price.textContent = input.dataset.price;
        submit.disabled = input.dataset.available !== 'true';
        submit.textContent = submit.disabled ? 'Sold out' : 'Add to cart';
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url);
      });
    });
  }
  function initAllOmMagnetic() {
    document.querySelectorAll('[data-om-magnetic]').forEach(initOmMagnetic);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllOmMagnetic);
  } else {
    initAllOmMagnetic();
  }
  document.addEventListener('shopify:section:load', initAllOmMagnetic);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["om-product"] && !Shopify.designMode) return;
  try {
    
  function setOmDeliveryEstimate(root) {
    const standardTarget = root.querySelector('[data-om-standard-date]');
    const priorityTarget = root.querySelector('[data-om-priority-date]');
    if (!standardTarget || !priorityTarget) return;
    const processingMin = Number(root.dataset.processingMin);
    const processingMax = Number(root.dataset.processingMax);
    const standardMin = Number(root.dataset.standardMin);
    const standardMax = Number(root.dataset.standardMax);
    const priorityMin = Number(root.dataset.priorityMin);
    const priorityMax = Number(root.dataset.priorityMax);
    if (!processingMin || !processingMax || !standardMin || !standardMax || !priorityMin || !priorityMax || processingMin > processingMax || standardMin > standardMax || priorityMin > priorityMax) {
      standardTarget.textContent = 'Shown at checkout';
      priorityTarget.textContent = 'Shown at checkout';
      return;
    }
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    const getPart = (type) => Number(parts.find((part) => part.type === type).value);
    const today = new Date(Date.UTC(getPart('year'), getPart('month') - 1, getPart('day')));
    const addBusinessDays = (date, days, holidays) => {
      const result = new Date(date);
      let added = 0;
      while (added < days) {
        result.setUTCDate(result.getUTCDate() + 1);
        const day = result.getUTCDay();
        if (day !== 0 && day !== 6 && !holidays.has(result.toISOString().slice(0, 10))) added++;
      }
      return result;
    };
    const fallback = () => {
      standardTarget.textContent = `${processingMin + standardMin}–${processingMax + standardMax} business days`;
      priorityTarget.textContent = `${processingMin + priorityMin}–${processingMax + priorityMax} business days`;
    };
    fallback();
    fetch('https://www.gov.uk/bank-holidays.json', { mode: 'cors' })
      .then((response) => {
        if (!response.ok) throw new Error('Bank holiday calendar unavailable');
        return response.json();
      })
      .then((calendar) => {
        const events = calendar['england-and-wales'] && calendar['england-and-wales'].events;
        if (!Array.isArray(events)) throw new Error('Bank holiday calendar unavailable');
        const holidays = new Set(events.map((event) => event.date));
        const formatter = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', timeZone: 'UTC' });
        const formatRange = (transitMin, transitMax) => {
          const earliest = addBusinessDays(addBusinessDays(today, processingMin, holidays), transitMin, holidays);
          const latest = addBusinessDays(addBusinessDays(today, processingMax, holidays), transitMax, holidays);
          return `${formatter.format(earliest)} – ${formatter.format(latest)}`;
        };
        standardTarget.textContent = formatRange(standardMin, standardMax);
        priorityTarget.textContent = formatRange(priorityMin, priorityMax);
      })
      .catch(fallback);
  }
  function initOmMagnetic(root) {
    if (root.dataset.omReady === 'true') return;
    root.dataset.omReady = 'true';
    setOmDeliveryEstimate(root);
    const hero = root.querySelector('[data-om-hero-image]');
    const heroLink = root.querySelector('[data-om-hero-link]');
    root.querySelectorAll('[data-om-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        hero.src = thumb.dataset.src;
        hero.alt = thumb.dataset.alt;
        heroLink.href = thumb.dataset.full;
        root.querySelectorAll('[data-om-thumb]').forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
      });
    });
    const variantId = root.querySelector('[data-om-variant-id]');
    const price = root.querySelector('[data-om-price]');
    const submit = root.querySelector('[data-om-submit]');
    root.querySelectorAll('[data-om-variant]').forEach((input) => {
      input.addEventListener('change', () => {
        variantId.value = input.value;
        price.textContent = input.dataset.price;
        submit.disabled = input.dataset.available !== 'true';
        submit.textContent = submit.disabled ? 'Sold out' : 'Add to cart';
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url);
      });
    });
  }
  function initAllOmMagnetic() {
    document.querySelectorAll('[data-om-magnetic]').forEach(initOmMagnetic);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllOmMagnetic);
  } else {
    initAllOmMagnetic();
  }
  document.addEventListener('shopify:section:load', initAllOmMagnetic);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["om-recommendations"] && !Shopify.designMode) return;
  try {
    
  function initOmRelated() {
    document.querySelectorAll('[data-om-related]').forEach((section) => {
      if (section.dataset.omRelatedReady === 'true') return;
      section.dataset.omRelatedReady = 'true';
      const track = section.querySelector('[data-om-related-track]');
      section.querySelector('[data-om-related-prev]').addEventListener('click', () => track.scrollBy({left: -track.clientWidth * .85, behavior: 'smooth'}));
      section.querySelector('[data-om-related-next]').addEventListener('click', () => track.scrollBy({left: track.clientWidth * .85, behavior: 'smooth'}));
      const loadRecommendations = () => {
        fetch(section.dataset.endpoint)
          .then((response) => response.ok ? response.text() : Promise.reject(new Error('Recommendations unavailable')))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newTrack = doc.querySelector('[data-om-related-track]');
            if (newTrack && newTrack.children.length) {
              track.innerHTML = newTrack.innerHTML;
              section.hidden = false;
            }
          })
          .catch(() => {});
      };
      if (section.hidden) {
        loadRecommendations();
      } else if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          loadRecommendations();
        }, {rootMargin: '300px'});
        observer.observe(section);
      } else {
        loadRecommendations();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initOmRelated);
  else initOmRelated();
  document.addEventListener('shopify:section:load', initOmRelated);

  } catch(e) { console.error(e); }
})();
})();
